<template>
  <div class="row">
    <div class="col_12">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">{{ $t('sidebar.questions.questions') }}</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row mt_10">
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.subject != '' && subjects.length
                            ? subjects.find(
                                (s) => s.id === parseInt(filter.subject)
                              ).name
                            : $t('common.subject')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="subjectFilter(subject.id)"
                          v-for="subject in subjects"
                          :key="'subject' + subject.id"
                        >
                          <a role="button">{{ subject.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.question_type != '' && question_types.length
                            ? question_types.find(
                                (s) => s.id === parseInt(filter.question_type)
                              ).name
                            : $t('common.question_type')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="questionTypeFilter(question_type.id)"
                          v-for="question_type in question_types"
                          :key="'question_type' + question_type.id"
                        >
                          <a role="button">{{ question_type.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.folder_grade != '' && folder_grades.length
                            ? folder_grades.find(
                                (s) => s.id === parseInt(filter.folder_grade)
                              ).name
                            : $t('common.folder_grade')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="folderGradeFilter(folder_grade.id)"
                          v-for="folder_grade in folder_grades"
                          :key="'folder_grade' + folder_grade.id"
                        >
                          <a role="button">{{ folder_grade.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.folder_semester != '' &&
                          folder_semesters.length
                            ? folder_semesters.find(
                                (s) => s.id === parseInt(filter.folder_semester)
                              ).name
                            : $t('common.folder_semester')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="folderSemesterFilter(folder_semester.id)"
                          v-for="folder_semester in folder_semesters"
                          :key="'folder_semester' + folder_semester.id"
                        >
                          <a role="button">{{ folder_semester.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <Multiselect
                  v-model="filter.folder_unit"
                  :placeholder="$t('common.select_folder_unit')"
                  :caret="false"
                  :close-on-select="false"
                  :searchable="true"
                  :create-option="true"
                  :hideSelected="false"
                  :options="folder_units"
                  @select="folderUnitFilter()"
                />
              </div>
              <!-- <div class="form-group ">
                    <div class="d_flex_start">
                      <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span> {{ filter.folder_unit != '' && folder_units.length ? folder_units.find(s=> s.id === parseInt(filter.folder_unit)).name : $t('common.folder_unit') }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="folderUnitFilter(folder_unit.id)" v-for="folder_unit in folder_units" :key="'folder_unit'+folder_unit.id"><a role="button">{{ folder_unit.name }}</a></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div> -->
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.difficulty != '' && difficulties.length
                            ? difficulties.find(
                                (s) => s.id === parseInt(filter.difficulty)
                              ).name
                            : $t('sidebar.difficulty.difficulty')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="difficultyFilter(difficulty.id)"
                          v-for="difficulty in difficulties"
                          :key="'difficulty' + difficulty.id"
                        >
                          <a role="button">{{ difficulty.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt_10">
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.grade != '' && grades.length
                            ? grades.find(
                                (s) => s.id === parseInt(filter.grade)
                              ).name
                            : $t('common.grade')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="gradeFilter(grade.id)"
                          v-for="grade in grades"
                          :key="'grade' + grade.id"
                        >
                          <a role="button">{{ grade.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.semester != '' && semesters.length
                            ? semesters.find(
                                (s) => s.id === parseInt(filter.semester)
                              ).name
                            : $t('common.semester')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="semesterFilter(semester.id)"
                          v-for="semester in semesters"
                          :key="'semester' + semester.id"
                        >
                          <a role="button">{{ semester.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <Multiselect
                  v-model="filter.unit"
                  :placeholder="$t('common.select_unit')"
                  :caret="false"
                  :close-on-select="false"
                  :searchable="true"
                  :create-option="true"
                  :hideSelected="false"
                  :options="units"
                  @select="unitFilter()"
                />
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.answer_type != '' && answerTypes.length
                            ? answerTypes.find(
                                (s) => s.type === filter.answer_type
                              ).translate
                            : $t('sidebar.questions.question_type')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="answerTypeFilter(answerType.type)"
                          v-for="answerType in answerTypes"
                          :key="'answerType' + answerType.id"
                        >
                          <a role="button">{{ answerType.translate }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_4">
              <div class="form-group">
                <div class="d_flex_end">
                  <div class="form_row_inline">
                    <input
                      type="text"
                      class="form_global"
                      :placeholder="$t('common.search')"
                      v-model="queryParams.search"
                    />
                  </div>
                  <div class="form_row_inline ml_10">
                    <div
                      class="btn btn_common_type_2 mr_10 width_150p"
                      @click="
                        queryParams.page = 1;
                        searchQuery();
                      "
                    >
                      {{ $t('common.search') }}
                    </div>
                    <div
                      class="btn btn_secondary width_150p"
                      @click="resetAll()"
                    >
                      {{ $t('common.reset') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_12">
              <div class="separator pl_0 pr_0">
                <span></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_12">
              <div class="d_flex_btwn pt_20 pb_20">
                <div class="d_flex_start col_2 pl_0">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>{{ filter.per_page }}</span>
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li @click="changePerPageFilter(10)">
                          <a role="button">10</a>
                        </li>
                        <li @click="changePerPageFilter(20)">
                          <a role="button">20</a>
                        </li>
                        <li @click="changePerPageFilter(50)">
                          <a role="button">50</a>
                        </li>
                        <li @click="changePerPageFilter(100)">
                          <a role="button">100</a>
                        </li>
                        <li @click="changePerPageFilter(200)">
                          <a role="button">200</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="d_flex_end col_10 pr_0">
                  <button
                    class="btn btn_md btn_danger mr_20"
                    @click.prevent="deleteQuestion()"
                  >
                    {{ $t('common.delete') }}
                  </button>
                  <router-link
                    :to="{ name: 'exam_questions_add' }"
                    class="btn btn_transparent"
                    >{{ $t('sidebar.questions.add_question') }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <table-component
            :columns="columns"
            :rows="questions"
            :pagination="pagination"
            @sorting="sorting"
            :sortable="sortable"
            @pageChanged="pageChanged"
          >
            <template #id="{ row }">
              <div class="form_checkbox">
                <input
                  type="checkbox"
                  :id="'question' + row.id"
                  :checked="checkedQuestion.includes(row.id)"
                  name="checkbox"
                />
                <label
                  :for="'question' + row.id"
                  @click="checkedSingleQuestion(row.id)"
                ></label>
              </div>
            </template>
            <template #question_type="{ row }">
              {{
                row.question_type === 'multiple-choice'
                  ? $t('sidebar.questions.multiple_choice')
                  : row.question_type === 'short-answer'
                  ? $t('sidebar.questions.short_answer')
                  : $t('sidebar.questions.descriptive')
              }}
            </template>
            <template #title="{ row }">
              <div
                class="text_shorten"
                v-html="convertTextEditor(row.title)"
              ></div>
            </template>
            <template #show_video="{ row }">
              <div class="">
                <button
                  class="btn btn_yellow ml_5"
                  @click.prevent="showAllVideo(row.question_videos)"
                  v-if="row.question_videos.length"
                >
                  {{ $t('common.show_video') }}
                </button>
              </div>
            </template>
            <template #action="{ row }">
              <div class="d_flex_center table_action_btn">
                <button
                  class="btn btn_info ml_10"
                  :title="$t('common.show')"
                  @click.prevent="showQuestion(row)"
                >
                  <i class="fas fa-eye"></i>
                </button>
                <button
                  class="btn btn_info ml_10"
                  :title="$t('common.clone')"
                  @click.prevent="cloneQuestion(row)"
                >
                  <i class="fas fa-clone"></i>
                </button>
                <router-link
                  :to="{ name: 'exam_questions_edit', params: { id: row.id } }"
                  :title="$t('common.edit')"
                  class="btn btn_blue ml_10"
                >
                  <img
                    :src="`${baseUrl}assets/media/images/icon/8.png`"
                    alt=""
                  />
                </router-link>
                <button
                  class="btn btn_danger ml_10"
                  :title="$t('common.delete')"
                  @click.prevent="deleteRecord(row)"
                >
                  <img
                    :src="`${baseUrl}assets/media/images/icon/9.png`"
                    alt=""
                  />
                </button>
              </div>
            </template>
          </table-component>
        </div>
      </div>
    </div>
    <question-modal
      v-if="questionModalShow"
      :showQuestionModal="questionModalShow"
      :questions="selectedQuestions"
      @closeModal="closeModal()"
    />
    <all-video-modal
      v-if="allVideoModalShow"
      :allVideoModalShow="allVideoModalShow"
      :videos="questionAllVideos"
      @closeModal="closeModal()"
    ></all-video-modal>
  </div>
</template>

<script>
import TableComponent from '@/components/shared/TableComponent';
import QuestionModal from '@/components/QuestionModal.vue';
import AllVideoModal from '../../lecture_management/components/AllVideoModal.vue';
import Mathml2latex from 'mathml-to-latex';
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    TableComponent,
    QuestionModal,
    Multiselect,
    AllVideoModal,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      questions: [],
      lectures: [],
      difficulties: [],
      subjects: [],
      semesters: [],
      grades: [],
      units: [],
      question_types: [],
      folder_grades: [],
      folder_semesters: [],
      folder_units: [],
      questionModalShow: false,
      selectedQuestions: [],
      checkedQuestion: [],
      answerTypes: [
        {
          id: 1,
          type: 'multiple-choice',
          translate: this.$t('sidebar.questions.multiple_choice'),
        },
        {
          id: 2,
          type: 'short-answer',
          translate: this.$t('sidebar.questions.short_answer'),
        },
        {
          id: 3,
          type: 'descriptive',
          translate: this.$t('sidebar.questions.descriptive'),
        },
      ],
      filter: {
        difficulty: '',
        subject: '',
        semester: '',
        grade: '',
        unit: '',
        question_type: '',
        folder_grade: '',
        folder_semester: '',
        folder_unit: '',
        answer_type: '',
        per_page: 20,
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'title',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20,
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc',
      },
      columns: [
        {
          label: '',
          field: 'id',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('common.subject'),
          field: 'subject.name',
          sortable: true,
        },
        {
          label: this.$t('common.grade'),
          field: 'grade.name',
          sortable: true,
        },
        {
          label: this.$t('common.semester'),
          field: 'semester.name',
          sortable: true,
        },
        {
          label: this.$t('common.folder_unit'),
          field: 'folder_unit.name',
          sortable: true,
        },
        {
          label: this.$t('common.unit'),
          field: 'unit.unit_name',
          sortable: true,
        },
        {
          label: this.$t('common.title'),
          field: 'title',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('sidebar.difficulty.difficulty'),
          field: 'difficulty.name',
          sortable: true,
        },
        {
          label: this.$t('sidebar.point.point'),
          field: 'point.point',
          sortable: true,
        },
        {
          label: this.$t('sidebar.questions.question_type'),
          field: 'question_type',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('sidebar.lectureCommon.convert_status'),
          field: 'video_convert_status',
          sortable: false,
        },
        {
          label: this.$t('common.video'),
          field: 'show_video',
          sortable: false,
          slot: true,
        },
        {
          label: this.$t('common.action'),
          field: 'action',
          sortable: false,
          slot: true,
        },
      ],
      allVideoModalShow: false,
      questionAllVideos: [],
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams());
        this.loadData();
      }
    },
  },
  created() {
    const query = this.getAllQueryParams();
    if (query.page) {
      this.setQueryData(query);
    }

    this.axios
      .get('/difficulties')
      .then((response) => (this.difficulties = response.data.data));
    this.axios
      .get('/subjects')
      .then((response) => (this.subjects = response.data.data));
    this.axios
      .get('/semesters')
      .then((response) => (this.semesters = response.data.data));
    this.axios
      .get('/grades')
      .then((response) => (this.grades = response.data.data));
    // this.axios.get('/units').then((response) => this.units = response.data.data);
    this.axios.get('/units').then((response) => {
      response.data.data.forEach((element) => {
        let unit = {
          value: element.id,
          label: element.unit_name,
        };
        this.units.push(unit);
      });
    });
    this.axios
      .get('/question_types')
      .then((response) => (this.question_types = response.data.data));
    this.axios
      .get('/folder_grades')
      .then((response) => (this.folder_grades = response.data.data));
    this.axios
      .get('/folder_semesters')
      .then((response) => (this.folder_semesters = response.data.data));
    // this.axios.get('/folder_units').then((response) => this.folder_units = response.data.data);

    this.axios.get('/folder_units').then((response) => {
      response.data.data.forEach((element) => {
        let unit = {
          value: element.id,
          label: element.name,
        };
        this.folder_units.push(unit);
      });
    });

    this.loadData();
  },
  updated() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });
  },
  mounted() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });
  },
  methods: {
    __convertTextEditor(string) {
      return string ? string.replace(/<img[^>]*>/g, '') : '';
    },
    convertTextEditor(string) {
      let parser = new DOMParser();
      const doc = parser.parseFromString(string, 'text/html');
      let mathTags = doc.getElementsByTagName('math');
      if (mathTags.length > 0) {
        [...mathTags].forEach((mathTag) => {
          mathTag.replaceWith(this.getLatex(mathTag.outerHTML));
        });

        return doc.body.innerHTML.replace(/<img[^>]*>/g, '');
      } else {
        return string ? string.replace(/<img[^>]*>/g, '') : '';
      }
    },
    getLatex(mathTag) {
      try {
        let latex = Mathml2latex.convert(mathTag);
        latex = this.sanitizeLatex(latex);
        latex = `\\[${latex}\\]`; // for block math
        return latex;
      } catch (error) {
        console.error('Latex conversion failed:', error);
        return mathTag; // fallback: keep original MathML
      }
    },
    sanitizeLatex(latex) {
      return latex
        .replace(/&nbsp;/g, ' ') // remove non-breaking spaces
        .replace(/\\left\\\(\\right\.\s*/g, '\\left(') // fix left paren
        .replace(/\s*\\left\.\s*\\right\\\)/g, '\\right)') // fix right paren
        .replace(/\s{2,}/g, ' ') // remove extra spaces
        .trim();
    },
    __getLatex(mathTag) {
      let latex = Mathml2latex.convert(mathTag);
      latex = '$$' + latex + '$$';
      latex = latex.replace(/\+\b/g, '\\\\');
      return latex;
    },
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page,
      };

      this.filter = {
        difficulty: query.difficulty,
        subject: query.subject,
        semester: query.semester,
        grade: query.grade,
        unit: query.unit,
        question_type: query.question_type,
        folder_grade: query.folder_grade,
        folder_semester: query.folder_semester,
        folder_unit: query.folder_unit,
        answer_type: query.answer_type,
        per_page: query.per_page,
      };
      this.sortable = {
        order: query.sort,
        sort: query.sort_order,
      };
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc',
      };
      this.filter = {
        difficulty: '',
        subject: '',
        semester: '',
        grade: '',
        unit: '',
        question_type: '',
        folder_grade: '',
        folder_semester: '',
        folder_unit: '',
        answer_type: '',
        per_page: 20,
      };

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'title',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20,
      };

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    difficultyFilter(id) {
      this.filter.difficulty = id;
      this.changeRoute();
    },
    subjectFilter(id) {
      this.filter.subject = id;
      this.changeRoute();
    },
    semesterFilter(id) {
      this.filter.semester = id;
      this.changeRoute();
    },
    gradeFilter(id) {
      this.filter.grade = id;
      this.changeRoute();
    },
    unitFilter() {
      this.changeRoute();
    },
    questionTypeFilter(id) {
      this.filter.question_type = id;
      this.changeRoute();
    },
    folderGradeFilter(id) {
      this.filter.folder_grade = id;
      this.changeRoute();
    },
    folderSemesterFilter(id) {
      this.filter.folder_semester = id;
      this.changeRoute();
    },
    folderUnitFilter() {
      // this.filter.folder_unit = id
      this.changeRoute();
    },
    answerTypeFilter(id) {
      this.filter.answer_type = id;
      this.changeRoute();
    },
    changePerPageFilter(per_page) {
      this.filter.per_page = per_page;
      this.changeRoute();
    },
    sorting({ column, order }) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.queryParams,
          ...this.filter,
        },
      });
    },
    loadData() {
      this.axios
        .get('/questions', {
          params: {
            ...this.queryParams,
            ...this.filter,
          },
        })
        .then((response) => {
          this.questions = response.data.data;
          this.pagination = response.data.meta;
        });
    },
    checkedSingleQuestion(id) {
      let index = window._.findIndex(
        this.checkedQuestion,
        (checkedQuestionId) => checkedQuestionId == id
      );
      if (index > -1) this.checkedQuestion.splice(index, 1);
      else this.checkedQuestion.push(id);
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/questions/' + row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            );
          });
        }
      });
    },
    showQuestion(exam) {
      this.selectedQuestions.push(exam);
      this.questionModalShow = true;
    },
    closeModal() {
      this.selectedQuestions = [];
      this.questionModalShow = false;
      this.allVideoModalShow = false;
    },
    cloneQuestion(row) {
      this.$swal({
        title: this.$t('common.cloneConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesClone'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.post('/question-clone/' + row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.cloned'),
              this.$t('common.cloneMessage'),
              'success'
            );
          });
        }
      });
    },
    showAllVideo(videos) {
      this.allVideoModalShow = true;
      this.questionAllVideos = videos;
    },
    deleteQuestion() {
      let questionIds = this.checkedQuestion;
      if (questionIds && questionIds.length > 0) {
        let formData = new FormData();
        formData.append('question_ids', JSON.stringify(questionIds));

        this.$swal({
          title: this.$t('common.deleteConfirmation'),
          text: this.$t('common.warning'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('common.yesDelete'),
          cancelButtonText: this.$t('common.noCancel'),
          confirmButtonColor: '#dd4b39',
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.axios.post('/selected-question-delete/', formData).then(() => {
              this.loadData();
              this.checkedQuestion = [];
              this.$swal.fire(
                this.$t('common.deleted'),
                this.$t('common.deleteMessage'),
                'success'
              );
            });
          }
        });
      } else {
        this.showFailMsg('No Questions Are Selected!');
      }
    },
  },
};
</script>

<style scoped>
.search_btn {
  padding: 10px 10px 10px 15px;
  margin: 0px 10px 0px 0px;
}

.reset_btn {
  padding: 10px 10px 10px 15px;
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
